import { render, staticRenderFns } from "./DrawCar.vue?vue&type=template&id=a22c7544&scoped=true"
import script from "./DrawCar.vue?vue&type=script&lang=js"
export * from "./DrawCar.vue?vue&type=script&lang=js"
import style0 from "./DrawCar.vue?vue&type=style&index=0&id=a22c7544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c7544",
  null
  
)

export default component.exports